import { render } from "./AreaPercentTReport.vue?vue&type=template&id=4c0d13cf&ts=true&lang=pug"
import script from "./AreaPercentTReport.vue?vue&type=script&lang=ts"
export * from "./AreaPercentTReport.vue?vue&type=script&lang=ts"

import "./AreaPercentTReport.vue?vue&type=style&index=0&id=4c0d13cf&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__